import { createFileRoute } from "@tanstack/react-router";

import RaAuth from "@/features/auth/RaAuth";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/raauth")({
  component: () => (
    <BasicLayout>
      <RaAuth />
    </BasicLayout>
  ),
});
